// extracted by mini-css-extract-plugin
module.exports = {"splash":"style_splash__Zqte6","LogoSplash":"style_LogoSplash__3DV_3","ppp":"style_ppp__3QW64","rotating":"style_rotating__1v2xk","rt":"style_rt__2sbet"};